export class AzureMarketplaceWebhookInputSubscriptionTerm {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "termUnit",
            "baseName": "termUnit",
            "type": "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
            "format": ""
        },
        {
            "name": "chargeDuration",
            "baseName": "chargeDuration",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureMarketplaceWebhookInputSubscriptionTerm.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum;
(function (AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum) {
    AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum["P1M"] = "P1M";
    AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum["P1Y"] = "P1Y";
})(AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum || (AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum = {}));
